import React, { memo, useCallback } from "react";
import { Card, Input, Controller, Button } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, message } from "antd";
import { usePostAuthorityAddCategory } from "core";

const NAME = "name";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};


const AddCategory = memo(() => {
  const { i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();


 const methods=useForm({
  defaultValues: {
    name: "",
  },
 })
 const { handleSubmit, reset } = methods;
  const { mutate, isPending } = usePostAuthorityAddCategory({
    onSuccess: () => {
      messageApi.open({
        type: 'success',
        content: i18n.t('done'),
      });
    },
  });

  const onSubmit = useCallback(
    ({ name }
      :
    { name:string }) => {
      mutate({
        requestBody: {
        name
        },
      });
      reset()
    },
    []
  );
  
 
  return (
    <>
 {contextHolder}

      <Card title={i18n.t("addCategory")}>
      <FormProvider {...methods}>

          <Form
            {...layout}
            name="nest-messages"
            onFinish={handleSubmit(onSubmit)}
          >
            <Form.Item>
              <Controller name={NAME}>
                <Input placeholder={i18n.t("categoryName")} />
              </Controller>
            </Form.Item>


            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
              <Button
                style={{ width: "100px" }}
                type="primary"
                isLoading={isPending}
                htmlType="submit"
              >
                {i18n.t("done")}
              </Button>
            </Form.Item>

          </Form>
          </FormProvider>
      </Card>
    </>
  );
});
export { AddCategory };
